export default __webpack_public_path__ + "static/media/total-invoice.97b24621.svg";